import { render, staticRenderFns } from "./NewsletterCard.vue?vue&type=template&id=21bc838f&"
import script from "./NewsletterCard.vue?vue&type=script&lang=js&"
export * from "./NewsletterCard.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports